import script from "./TgContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgContainer.vue?vue&type=script&lang=ts&setup=true"

import "./TgContainer.vue?vue&type=style&index=0&id=1c0a15d4&lang=css"

const __exports__ = script;

export default __exports__